import Vue from 'vue'
import App from './App.vue'
import router from './router'
import "ant-design-vue/dist/antd.less";
import './antConfig'
import qs from 'qs'
console.log(qs)
import axios from 'axios'
Vue.prototype.qs=qs;
Vue.prototype.$http = axios
axios.defaults.baseURL = Vue.prototype.$BASE_URI ='https://api.09dt.net/dt'//https://api.09dt.net/dt/dev//https://api.09dt.net/dt
axios.defaults.withCredentials=true
axios.defaults.timeout=1800000
Vue.config.productionTip = false
import Load from './components/Loading'
Vue.use(Load);
let vue = new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
if(localStorage.getItem('userInfo')){
    if(location.href.indexOf('/login')>=0){
        router.replace({name:'home'})
    }
}else{
    router.replace({name:'login'})
}
router.beforeEach((to, from, next) => {
    if(localStorage.getItem('userInfo')){
        if(to.name==='login'){
            sessionStorage.setItem('actionMenu',JSON.stringify(['home']))
            next({path:'/home'})
            return false;
        }
        if(!to.name){
            sessionStorage.setItem('actionMenu',JSON.stringify(['home']))
            next({path:'/home'})
        }else{
            next()
        }
    }else{
        if(to.name==='login'){
            next()
        }else{
            next({path:'/login'})
        }
    }

})
axios.interceptors.response.use(function (res) {
    console.log(res)
    if(res.data){
        res.data.$vue=vue;
        res.data.$router=router;
        if(res.data.code===20000){
            return res.data;
        }else if(res.data.code===30001){
            localStorage.removeItem('userInfo')
            res.data.$vue.$Message.error(res.data.msg)
            sessionStorage.removeItem('actionMenu')
            res.data.$vue.$router.replace({name:'login'})
        }else{
            vue.$Message.error(res.data.msg)
            return Promise.reject(res.data.msg)
        }
    }
})
axios.interceptors.request.use(function (config) {
    const token = localStorage.getItem('token')
    if (token ) { // 判断是否存在token，如果存在的话，则每个http header都加上token
        config.headers.Authorization ='Bearer ' + token  //请求头加上token
    }
    return config
})
Vue.filter('trans-date', function (tm) {
    if (tm < 10000000000) {
        tm = tm * 1000;
    }
    var tt = new Date(parseInt(tm));
    var yy=tt.getFullYear();
    if((tt.getMonth()+1)<10){
        var mm='0'+(tt.getMonth()+1)
    }else{
        var mm=tt.getMonth()+1;
    }
    if(tt.getDate()<10){
        var dd='0'+tt.getDate();
    }else{
        var dd=tt.getDate();
    }
    if(tt.getHours()<10){
        var hh='0'+tt.getHours();
    }else {
        var hh=tt.getHours();
    }
    if(tt.getMinutes()<10){
        var cc='0'+tt.getMinutes();
    }else {
        var cc=tt.getMinutes();
    }
    if(tt.getSeconds()<10){
        var ss='0'+tt.getSeconds();
    }else {
        var ss=tt.getSeconds();
    }
    var YY=new Date().getFullYear();
    var MM=new Date().getMonth()+1;
    var DD=new Date().getDate();
    if((new Date().getMonth()+1)<10){
        MM='0'+(new Date().getMonth()+1);
    }else{
        MM=new Date().getMonth()+1;
    }
    if((new Date().getDate())<10){
        DD='0'+new Date().getDate();
    }else{
        DD=new Date().getDate();
    }
    return yy + "-" + mm + "-" + dd + " " + hh + ":" + cc + ":" + ss;
})
